import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/sections/home/view/home-view.js");
